module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-BOOSTER-GREEN-4.f1c2aaee.jpg";